// src/components/HomeLayout.jsx
import React from "react";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function HomeLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Top area: Header & Navbar */}
      <Header />
      <Navbar />

      {/* Main Content Area */}
      <main className="flex-1 overflow-auto bg-muted">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
